"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var CommunityPost = function CommunityPost(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/media/community_post-community-post" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-community-post" + unique,
    xlinkHref: "#path-1-community-post" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-community-post" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.21579372,13.7052377 L9.16666667,14 L8.67703296,14 C8.26812837,14 7.90041962,14.2489509 7.74855627,14.6286093 L6.54855627,17.6286093 C6.50130816,17.7467296 6.47703296,17.8727806 6.47703296,18 C6.47703296,18.5522847 6.92474821,19 7.47703296,19 L12.5302546,19 C12.655928,19 12.7804754,18.9763111 12.8973736,18.930174 C13.4110945,18.7274198 13.6631828,18.1466019 13.4604286,17.632881 L12.2763954,14.632881 C12.1256631,14.2509688 11.7568029,14 11.3462214,14 L10.8333333,14 L10.7842063,13.7052377 C11.2136262,13.3534091 11.5,12.7212953 11.5,12 C11.5,10.8954305 10.8284271,10 10,10 C9.17157288,10 8.5,10.8954305 8.5,12 C8.5,12.7212953 8.7863738,13.3534091 9.21579372,13.7052377 Z M5,2 L13.7928932,2 C13.9255015,2 14.0526784,2.05267842 14.1464466,2.14644661 L19.8535534,7.85355339 C19.9473216,7.94732158 20,8.07449854 20,8.20710678 L20,21 C20,21.5522847 19.5522847,22 19,22 L5,22 C4.44771525,22 4,21.5522847 4,21 L4,3 C4,2.44771525 4.44771525,2 5,2 Z M13,4 L13,9 L18,9 L13,4 Z",
    fill: "inherit",
    id: "path-1-community-post" + unique
  }))));
};

CommunityPost.propTypes = propTypes;
var _default = CommunityPost;
exports["default"] = _default;